var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConnected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0.25C2.825 0.25 0.25 2.825 0.25 6C0.25 9.175 2.825 11.75 6 11.75C9.175 11.75 11.75 9.175 11.75 6C11.75 2.825 9.175 0.25 6 0.25ZM9.175 4.175L5.175 8.175C5.125 8.225 5.075 8.25 5 8.25C4.925 8.25 4.875 8.225 4.825 8.175L2.825 6.175C2.725 6.075 2.725 5.925 2.825 5.825C2.925 5.725 3.075 5.725 3.175 5.825L5 7.65L8.825 3.825C8.925 3.725 9.075 3.725 9.175 3.825C9.275 3.925 9.275 4.075 9.175 4.175Z",
    fill: "#1F5274"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnected);
export default __webpack_public_path__ + "static/media/connected.b4a27e92357add0ae8319911f23b5293.svg";
export { ForwardRef as ReactComponent };